export default __webpack_public_path__ + "static/media/volume_off_branco.a5bfd648.svg";